var map = {
	"./article-1.jpg": "4bb7",
	"./article-2.jpg": "60c0",
	"./article-3.jpg": "8166",
	"./article-4.jpg": "c183",
	"./article-5.jpg": "0b22",
	"./article-6.jpg": "b69a",
	"./article-7.jpg": "0c76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e324";